import * as React from 'react';

import styled from 'styled-components';

export interface SearchIconProps {
  className?: string;
}

export const SearchIcon: React.FC<SearchIconProps> = (props) => {
  return (
    <svg viewBox="0 0 24 24" className={props.className}>
      <path
        className="handle"
        d="M14.3 16.2c-0.4-0.4-0.4-1 0-1.4 0.4-0.4 1-0.4 1.4 0l4 4c0.4 0.4 0.4 1 0 1.4 -0.4 0.4-1 0.4-1.4 0L14.3 16.2z"
      />
      <path
        className="circle"
        d="M11 17.5c-2.5 0-4.8-1.3-6.1-3.5 -1.3-2.2-1.3-4.8 0-7S8.5 3.5 11 3.5c3.9 0 7 3.1 7 7S14.9 17.5 11 17.5zM11 15.5c2.8 0 5-2.2 5-5s-2.2-5-5-5c-2.8 0-5 2.2-5 5S8.2 15.5 11 15.5z"
      />
    </svg>
  );
};

export default styled(SearchIcon)`
  width: 24px;
  height: 24px;

  .circle,
  .handle {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
